import React from 'react';
import { FlexiflowComponent } from '@flexiflow-ui-kit/system';
import styled, { keyframes } from 'styled-components';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2;
var rotateKeyframe = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  to {\n    transform: rotate(360deg);\n  }\n"])));
var Spinner$1 = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: block;\n  box-sizing: border-box;\n  min-width: 2em;\n  max-width: 2em;\n  min-height: 2em;\n  max-height: 2em;\n  font-family: ", ";\n  font-size: ", "px;\n  border: ", "px solid ", ";\n  border-left-color: transparent;\n  border-radius: 50%;\n  animation: ", " 0.9s ease infinite;\n"])), function (p) {
  return p.theme.fonts.text;
}, function (p) {
  return p.radius;
}, function (p) {
  return p.thickness;
}, function (p) {
  return p.color || p.theme.palette.black;
}, rotateKeyframe);

function Spinner(_ref) {
  var _ref$radius = _ref.radius,
      radius = _ref$radius === void 0 ? 12 : _ref$radius,
      color = _ref.color,
      _ref$thickness = _ref.thickness,
      thickness = _ref$thickness === void 0 ? 2 : _ref$thickness,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(FlexiflowComponent, null, /*#__PURE__*/React.createElement(Spinner$1, {
    thickness: thickness,
    radius: radius,
    color: color,
    className: className
  }));
}

export { Spinner };
